import { useForm, Head } from '@inertiajs/react';
import { useEffect } from 'react';
import GuestLayout from '@/Layouts/GuestLayout';

export default function Login() {
    const { data, setData, post, processing, errors, reset } = useForm({
        email: '',
        password: '',
    });

    useEffect(() => {
        return () => {
            reset('password');
        };
    }, []);

    const submit = (e) => {
        e.preventDefault();
        post(route('login'));
    };

    return (
        <GuestLayout>
            <Head title="ورود" />

            <div className="mb-6 text-center">
                <h2 className="text-2xl font-extrabold text-slate-100">ورود به حساب کاربری</h2>
                <p className="mt-1 text-sm text-slate-400">برای ادامه اطلاعات خود را وارد کنید</p>
            </div>

            <form className="space-y-5" onSubmit={submit}>
                <div>
                    <label htmlFor="email" className="label">ایمیل</label>
                    <input
                        id="email"
                        name="email"
                        type="email"
                        required
                        autoFocus
                        className="input"
                        placeholder="you@example.com"
                        value={data.email}
                        onChange={(e) => setData('email', e.target.value)}
                    />
                    {errors.email && <div className="mt-1.5 text-sm text-rose-400">{errors.email}</div>}
                </div>

                <div>
                    <label htmlFor="password" className="label">رمز عبور</label>
                    <input
                        id="password"
                        name="password"
                        type="password"
                        required
                        className="input"
                        placeholder="••••••••"
                        value={data.password}
                        onChange={(e) => setData('password', e.target.value)}
                    />
                    {errors.password && <div className="mt-1.5 text-sm text-rose-400">{errors.password}</div>}
                </div>

                <button type="submit" disabled={processing} className="btn-primary w-full">
                    {processing ? 'در حال ورود...' : 'ورود'}
                </button>

                <div className="text-center text-sm text-slate-400">
                    حساب کاربری ندارید؟{' '}
                    <a href={route('register')} className="font-semibold text-brand-400 hover:text-brand-300">
                        ثبت‌نام
                    </a>
                </div>
            </form>
        </GuestLayout>
    );
}
